
import { PusherService } from './pusher.service';

const moduleName = "pusher";

angular.module(moduleName, [])
  .service("PusherService", PusherService);

export default {
  moduleName,
};

/**
 * @typedef {object} IPusherService
 * @property {(userId: string) => void} connect
 */